<template>
  <q-page>
    <div class="q-ma-md render-container" v-html="renderedMd"></div>
  </q-page>
</template>

<script>
import { updateCustomMd } from '../../js/customMdParse/customMdParse'

export default {
  name: 'home',
  data () {
    return {
      content: `# Interface
Subinds interface is quite basic.  On the left is the *note tree* which displays all of your
notes and sub-notes. The rest of the screen is taken up by the current note.  Submind uses a
split code/rendered view rather than focusing on a mixed editor like most note taking apps.

<div style="text-align: center;">
  <img width="80%" src="https://firebasestorage.googleapis.com/v0/b/submindfire.appspot.com/o/InterfaceLabelled.png?alt=media&token=edd933da-97ec-445e-8a45-487bb6644919" class="shadow-2" alt="Interface Labelled">
</div>

Typing in the *code* panel will update the rendered view and save the note.

The editor selector in the top right allows you to select which panels you want to display.

<div style="text-align: center;">
  <img width="50%" src="https://firebasestorage.googleapis.com/v0/b/submindfire.appspot.com/o/editorselector.gif?alt=media&token=472a4434-0063-401d-9c5d-23beb9c57111" class="shadow-2" alt="Editor Selector">
</div>

The immersive mode button hides all distractions, leaving you with only the current note to
focus on.  If you click the dropdown and select fullscreen, the app will enter fullscreen
immersive mode.
<div style="text-align: center;">
  <img width="50%" src="https://firebasestorage.googleapis.com/v0/b/submindfire.appspot.com/o/immersivemode.gif?alt=media&token=d4e66894-da65-4caa-adbb-d7e60c89a34b" class="shadow-2" alt="Immersive Mode">
</div>

## PWA

Submind is built as a [Progressive Web App](https://medium.freecodecamp.org/progressive-web-apps-bridging-the-gap-between-web-and-mobile-apps-a08c76e3e768)
which means that it works both online and offline, loads quickly and can be used on both desktop
and mobile devices. Using PWA with [Google Cloud Firestore](https://firebase.google.com/docs/firestore/)
allows for an extremely flexible

`,
      renderedMd: '',
      componentDefinitionAry: []
    }
  },
  mounted () {
    this.renderedMd = updateCustomMd(this.content || '', this.componentDefinitionAry, this.item, null, false, this.saveThrottled) // eslint-disable-line vue/no-side-effects-in-computed-properties
    this.renderedMd = this.renderedMd + '<div style="width: 100%; height: 25vh;"></div>' // eslint-disable-line vue/no-side-effects-in-computed-properties
    // updateComponentHtmlInDOM()
  }
}
</script>

<style scoped>

</style>
